/**
 * PriceTable — 분양가 표 (목업 `table.prices`).
 *
 * 순수 프레젠테이션. 층/공급세대/실분양가 3열, 우측정렬(첫 열만 좌측).
 * 숫자는 tabular-nums, 실분양가 열은 강조(볼드). hot 행은 surface 배경으로 강조.
 * note 는 표 하단 회색 보조 텍스트.
 */

import React from 'react';

export interface PriceTableRow {
  floor: string;
  supplyCount?: number | null;
  price: string;
  /** 강조 행 여부 (목업 `tr.hot`). */
  hot?: boolean;
}

export interface PriceTableProps {
  rows: PriceTableRow[];
  note?: React.ReactNode;
  className?: string;
}

export function PriceTable({ rows, note, className = '' }: PriceTableProps) {
  return (
    <div className={className}>
      <table className="w-full border-collapse text-[12.5px]">
        <thead>
          <tr>
            <th className="border-b border-ca-line px-1 py-2 text-left text-[11px] font-bold text-muted">
              층
            </th>
            <th className="border-b border-ca-line px-1 py-2 text-right text-[11px] font-bold text-muted">
              공급세대
            </th>
            <th className="border-b border-ca-line px-1 py-2 text-right text-[11px] font-bold text-muted">
              실분양가
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i} className={row.hot ? 'bg-ca-surface' : ''}>
              <td className="border-t border-ca-line-soft px-1 py-2 text-left text-body">
                {row.floor}
              </td>
              <td className="border-t border-ca-line-soft px-1 py-2 text-right tabular-nums text-body">
                {row.supplyCount ?? ''}
              </td>
              <td className="border-t border-ca-line-soft px-1 py-2 text-right font-extrabold tabular-nums text-ink">
                {row.price}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {note && (
        <div className="mt-[9px] flex justify-between gap-2 text-[11.5px] text-muted">{note}</div>
      )}
    </div>
  );
}

export default PriceTable;
